(() => {
    function formatEventDates(container = document) {
        container.querySelectorAll('[data-events-page]').forEach(page => {
            const dateOnlyFormatter = new Intl.DateTimeFormat('en-CA', {
                timeZone: 'UTC', weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
            });
            let formatter;
            try {
                formatter = new Intl.DateTimeFormat('en-CA', {
                    timeZone: page.dataset.timezone || 'America/Toronto',
                    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
                    hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
                });
            } catch {
                return; // Keep the server-rendered time and UTC offset if a setting is invalid.
            }
            page.querySelectorAll('[data-event-time]').forEach(time => {
                const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(time.dateTime);
                const date = new Date(time.dateTime);
                if (!Number.isNaN(date.getTime())) {
                    // A calendar date has no time zone; preserve its day instead of converting midnight.
                    time.textContent = (isDateOnly ? dateOnlyFormatter : formatter).format(date);
                }
            });
        });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => formatEventDates());
    } else {
        formatEventDates();
    }
    document.addEventListener('shopify:section:load', event => formatEventDates(event.target));
})();
